import React, { FC, useContext, useEffect } from "react";
import Banner from "components/banner";
import { MembersByMembershipTable } from "components/tableComponents/membersTable";
import TopBar from "components/tableComponents/topBar";
import SearchField from "components/tableComponents/paginationSearchField";
import { ProfileContext } from "contexts/profile";
import { usePaginationStore } from "utils/usePaginationStore";
import { useParams } from "react-router-dom";
import { MembershipsContext } from "contexts/memberships";
import { AvailableSubscriptionsTable } from "components/tableComponents/availableSubscriptionsTable";

export const MembersView: FC = () => {
    const { selectedOrganization } = useContext(ProfileContext);
    const { membership, isFetchingMemberships, fetchMembership } = useContext(MembershipsContext);
    const { membershipId } = useParams<{ membershipId: string }>();

    const memberPagination = usePaginationStore("member-subscription-associations", undefined, {
        org_nr: selectedOrganization.org_nr,
        membership_id: membershipId,
        page_size: 20,
        default_page_size: 20,
    });

    const availableSubscriptionPagination = usePaginationStore("available-subscriptions", undefined, {
        membership_id: membershipId,
        page_size: 20,
        default_page_size: 20,
    });

    useEffect(() => {
        if (membershipId != null) {
            fetchMembership(Number(membershipId));
        }
        // eslint-disable-next-line
    }, []);
    const refreshTables = (): Promise<void> => {
        memberPagination.query.refetch();
        return availableSubscriptionPagination.query.refetch().then(() => {
            return;
        });
    };

    if (membership != null && !isFetchingMemberships) {
        return (
            <div className="contentWrapper">
                <Banner
                    title="members"
                    subTitle="bannerManageMembers"
                    imageStyle={{ objectPosition: "90% 10%" }}
                    image={`${process.env.PUBLIC_URL}/assets/images/representatives/users.jpg`}
                />

                <AvailableSubscriptionsTable pagination={availableSubscriptionPagination} membership={membership} refreshTable={refreshTables} />

                <TopBar
                    titleTag="membersAddedToSubscription" singleItem={<SearchField pagination={memberPagination} />} />
                <MembersByMembershipTable pagination={memberPagination} refreshTable={refreshTables} />
            </div>
        );
    } else {
        return <div></div>;
    }

};